import React from "react";
import { Skeleton } from 'primereact/skeleton';


const RectangleRowWithNineColSkeleton = () => {
    return(
        <div className="flex flex-row justify-content-between">
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 mr-2" />
            <Skeleton shape="rectangle" height="2rem" width="9rem" className="mb-2 " />
        </div>
    )
}

export default RectangleRowWithNineColSkeleton;